// Models
import { createOtpStoreDefaultModel } from './otp/otp.store'

const otpModels = {
  otp: createOtpStoreDefaultModel(),
}

export { otpModels }
